import { render, staticRenderFns } from "./help-video.vue?vue&type=template&id=e50e1c18&"
import script from "./help-video.vue?vue&type=script&lang=js&"
export * from "./help-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports